import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TextareaModule } from 'primeng/textarea';
import { TranslateModule } from '@ngx-translate/core';
import { AppButtonComponent } from '@app/shared/components/app-button/app-button.component';

@Component({
  selector: 'app-return-exception-cancel-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TextareaModule,
    TranslateModule,
    AppButtonComponent,
  ],
  templateUrl: './return-exception-cancel-dialog.component.html',
  styleUrl: './return-exception-cancel-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReturnExceptionCancelDialogComponent {
  private readonly dialogRef = inject(DynamicDialogRef);

  cancelReason = signal('');

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    const reason = this.cancelReason()?.trim();
    if (!reason) {
      return;
    }
    this.dialogRef.close(reason);
  }
}
